<template>
  <div class="form-floating">
    <select
      @change="seleccionado($event)"
      v-model="idAplicado"
      v-bind="$attrs"
      class="form-select"
      id="floatingSelect"
      aria-label="Comercio"
    >
      <option v-bind:value="null">Seleccionar</option>
      <option
        v-for="comer in comercioList"
        v-bind:key="comer.id"
        v-bind:value="comer.id"
      >
        {{ comer.name }}
      </option>
    </select>
    <label for="floatingSelect">Comercio</label>
  </div>
</template>
<script>
const EVENTO_SELECCIONADO = "evento-seleccionado";
import { ComercioFacade } from "../../../admin/comercio/comercio.facade";

export default {
  inheritAttrs: false,
  props: {
    idActual: {
      type: String,
      default: null
    },
    idFijo: {
      type: String,
      default: null
    },
  },
  data() {
    return {
      idAplicado: this.idActual,
      comercioList: undefined
    };
  },
  watch: {
    idActual(valor) {
      // Cuando hay idFijo, no se cambia el idComercio
      if (!this.idFijo) this.idAplicado = valor;
    },
    idFijo(valor) {
      this.seleccionar(valor);
    },
    list(newValue, oldValue) {
      if (newValue && !oldValue) {
        if (this.idFijo) {
          this.seleccionar(this.idFijo);
        }
      }
    }
  },
  methods: {
    seleccionado: async function(event) {
      this.seleccionar(event.target.value);
    },
    seleccionar(comercioId) {
      this.idAplicado = comercioId;
      const comercio = this.getComercio(this.idAplicado);
      this.$emit(EVENTO_SELECCIONADO, comercio);
    },
    getComercio(comercioId) {
      return this.comercioList.find(c => c.id == comercioId);
    }
  },
  mounted() {
    ComercioFacade.getActiveList().then(response => {
      this.comercioList = response.data;
    });
    
  }
};
</script>
